
import { useDataEngine } from '@dhis2/app-runtime';
import { useEffect, useState, useMemo } from 'react';

// useObjectiveWeight.js
export const useObjectiveWeight = (positionTei) => {
  const engine = useDataEngine();
  const [totalWeight, setTotalWeight] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get fiscal year from localStorage (same source as ObjectiveList)
  const fiscalYear = useMemo(() => {
    if (typeof window === 'undefined') return null;
    const stored = localStorage.getItem('company_financial_calendar');
    if (stored) {
      try {
        const config = JSON.parse(stored);
        if (config.financialYearStart && config.financialYearEnd) {
          return { start: config.financialYearStart, end: config.financialYearEnd };
        }
      } catch (e) {
        console.warn('Failed to parse fiscal year from localStorage');
      }
    }
    return null;
  }, []);

  useEffect(() => {
    const loadTotalWeight = async () => {
      // ✅ If no positionTei, return 0
      if (!positionTei) {
        setTotalWeight(0);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Build filter conditions
        const filters = [
          `SlgO60cMK3F:eq:${positionTei}`
        ];
        
        // Add fiscal year filter if available
        if (fiscalYear?.start && fiscalYear?.end) {
          // Filter by start date within fiscal year
          filters.push(`eDcVy661j9e:ge:${fiscalYear.start}`);
          filters.push(`eDcVy661j9e:le:${fiscalYear.end}`);
        }

        const response = await engine.query({
          objectives: {
            resource: 'events',
            params: {
              program: 'yiT00XKrrHP',
              programStage: 'VIBtpvkpHFR',
              filter: filters.join(';'),
              fields: 'dataValues[dataElement,value]',
            },
          },
        });

        const events = response.objectives?.events || [];
        let total = 0;
        for (const event of events) {
          const weightDV = event.dataValues?.find(dv => dv.dataElement === 'yfb9RCRpMB2');
          const weight = parseFloat(weightDV?.value);
          if (!isNaN(weight)) total += weight;
        }

        setTotalWeight(total);
      } catch (err) {
        console.error('Failed to load objective weight:', err);
        setTotalWeight(0);
      } finally {
        setLoading(false);
      }
    };

    loadTotalWeight();
  }, [positionTei, engine, fiscalYear?.start, fiscalYear?.end]);

  return { totalWeight, loading };
};